import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { PLANXGO_TRANSLATIONS } from './planxgo.translations';

export class PlanxgoCombinedTranslateLoader implements TranslateLoader {
  private httpLoader: TranslateHttpLoader;

  constructor(http: HttpClient) {
    this.httpLoader = new TranslateHttpLoader(http, './assets/I18N/locale-', '.json');
  }

  getTranslation(lang: string): Observable<any> {
    const normalized = (lang || '').toLowerCase().replace('-', '_');
    const baseLang = normalized.split('_')[0];
    const planxgoKeys =
      PLANXGO_TRANSLATIONS[lang] ??
      PLANXGO_TRANSLATIONS[normalized] ??
      PLANXGO_TRANSLATIONS[baseLang] ??
      PLANXGO_TRANSLATIONS['en'];
    return this.httpLoader.getTranslation(lang).pipe(
      map((httpKeys) => ({ ...httpKeys, ...planxgoKeys })),
      catchError(() => of(planxgoKeys)),
    );
  }
}

export function createPlanxgoCombinedTranslateLoader(http: HttpClient): TranslateLoader {
  return new PlanxgoCombinedTranslateLoader(http);
}
